import { actionCreatorFactory } from 'typescript-fsa';
import { IResolverMeta } from '@cbridge-utils/redux-observable';
import { IUserForm } from './user.interface';

export namespace UserAction {
  const actionCreator = actionCreatorFactory('User');

  export interface ICreateUserParams extends Pick<IResolverMeta, 'reject'> {
    user: IUserForm,
    resolve?: (userId: string) => void,
  }

  export const create = actionCreator<ICreateUserParams>('CREATE');
  export const createDone = actionCreator<{ userId: string }>('CREATE_DONE');
  export const createFailed = actionCreator('CREATE_FAILED');
}
